import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function PaiementHintExpiryDateIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 27 18"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...(size !== undefined && { width: size, height: size })}
			{...props}
		>
			<g clipPath="url(#clip0_7583_31368)">
				<path
					d="M0 3.375C0 1.51104 1.51104 0 3.375 0H23.625C25.489 0 27 1.51104 27 3.375V14.625C27 16.489 25.489 18 23.625 18H3.375C1.51104 18 0 16.489 0 14.625V3.375Z"
					fill="#E6E9EB"
				/>
				<path
					d="M23.0625 9H3.9375C3.62684 9 3.375 9.25184 3.375 9.5625V10.6875C3.375 10.9982 3.62684 11.25 3.9375 11.25H23.0625C23.3732 11.25 23.625 10.9982 23.625 10.6875V9.5625C23.625 9.25184 23.3732 9 23.0625 9Z"
					fill="#B9C4C9"
				/>
				<path
					d="M6.1875 3.375H3.9375C3.62684 3.375 3.375 3.62684 3.375 3.9375V6.1875C3.375 6.49816 3.62684 6.75 3.9375 6.75H6.1875C6.49816 6.75 6.75 6.49816 6.75 6.1875V3.9375C6.75 3.62684 6.49816 3.375 6.1875 3.375Z"
					fill="white"
				/>
				<path
					d="M17.4375 11.8125H15.1875C13.9449 11.8125 12.9375 12.8199 12.9375 14.0625C12.9375 15.3051 13.9449 16.3125 15.1875 16.3125H17.4375C18.6801 16.3125 19.6875 15.3051 19.6875 14.0625C19.6875 12.8199 18.6801 11.8125 17.4375 11.8125Z"
					stroke="#B2231E"
				/>
			</g>
			<defs>
				<clipPath id="clip0_7583_31368">
					<rect width="27" height="18" fill="white" />
				</clipPath>
			</defs>
		</svg>
	);
}

PaiementHintExpiryDateIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default PaiementHintExpiryDateIcon;
